<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong> トップページ </strong>
      </CCardHeader>
      <CCardBody>
        <div v-for="data in this.datalists" v-bind:key="data.detail">
          <h4>{{ data.title }}</h4>
          <br />
          <p>  {{ data.value }}</p>
          <p>  <span v-html="data.detail.replace(/\n/g,'<br/>')"/></p>
          <br />
        </div>
        <!--              Notification<br>
                <a href="/">経歴情報を更新してください。</a><br>
                <a href="/">未承認の受講報告があります。</a><br>
        <a href="/">受講報告が棄却されました。</a> -->
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import information from '../../../maintenance/information.json';
export default {
  name: "TopPage",
  data() {
    return {
      datalists: information,
    };
  },
};
</script>